// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  expandRow,
  loadTransactions,
  downloadCsv,
  changeSortOrder,
  showTooltip
} from './reducer/transactions';
import {
  setSearchFilter,
  setCommissionStatusFilter,
  toggleCalendarFilter,
  clearCalendarFilter,
  setCalendarStartFilter,
  setCalendarEndFilter,
  setCalendarSaga,
  setPerPageFilter,
  changePage
} from './reducer/filters';
import { type Currencies } from '../../../utilities/types';
import MerchantTransactionTable from './MerchantTransactionTable';
import MerchantTransactionFilters from './MerchantTransactionFilters';
import { MerchantsDiv } from '../MerchantsStyles';
import { resetState } from '../../reducer';

export type Transaction = {
  created_at: string,
  id: number,
  status: string,
  settlement_method: string,
  currency: string,
  revenue_share: string,
  fees: string,
  merchant_name: string,
  amount_received: string,
  amount_in_fiat_received: string,
  fiat_currency: string,
  transaction_id: number,
  transaction_fee: string,
  transaction_amount: string
};
type Props = {
  expandedRow: number,
  currentPage: number,
  changePage: (value: number) => void,
  downloadCsv: () => void,
  previouslyVisited: number[],
  expandRow: (id: number) => void,
  loadTransactions: (params: {}) => void,
  transactions: Transaction[],
  transactionsFailedLoad: boolean,
  transactionsLoading: boolean,
  currencies: Currencies,
  search: string,
  setSearchFilter: (value: string) => void,
  commissionStatus: ?string,
  setCommissionStatusFilter: (value: string) => void,
  toggleCalendarFilter: () => void,
  calendarFilterState: boolean,
  startDate?: string,
  endDate?: string,
  clearCalendarFilter: () => void,
  setCalendarStartFilter: (date: ?moment$Moment) => void,
  setCalendarEndFilter: (date: ?moment$Moment) => void,
  setCalendarSaga: () => void,
  perPage: string,
  setPerPageFilter: (perPage: number) => void,
  orderBy: ?string,
  orderDirection: ?string,
  changeSortOrder: (orderBy: string) => void,
  transactionLoading: boolean,
  showTooltip: (tooltip: string) => void,
  activeTooltip: ?string,
  viewportDevice: string,
  paginatorTotal: number,
  resetState: () => void
};

class MerchantTransaction extends Component<Props> {
  componentDidMount() {
    if (this.props.transactionsLoading) {
      this.props.loadTransactions({
        page: this.props.currentPage,
        perPage: 25
      });
    }
  }

  componentWillUnmount() {
    this.props.resetState();
  }

  render() {
    const availableCommissionStatusFilters = [
      { text: 'Paid', value: 'paid' },
      { text: 'Refunded', value: 'refunded' },
      { text: 'Completed', value: 'completed' }
    ];
    return (
      <>
        <MerchantTransactionFilters
          // Search Filter props
          searchValue={this.props.search}
          setSearchFilter={this.props.setSearchFilter}
          // Status Filter props
          commissionStatusFilter={this.props.commissionStatus}
          setCommissionStatusFilter={this.props.setCommissionStatusFilter}
          availableCommissionStatusesFilter={availableCommissionStatusFilters}
          // Date Filter
          toggleCalendarFilter={this.props.toggleCalendarFilter}
          calendarFilterState={this.props.calendarFilterState}
          calendarStart={this.props.startDate}
          calendarEnd={this.props.endDate}
          clearCalendarFilter={this.props.clearCalendarFilter}
          setCalendarStartFilter={this.props.setCalendarStartFilter}
          setCalendarEndFilter={this.props.setCalendarEndFilter}
          windowSize={this.props.viewportDevice}
          setCalendarSaga={this.props.setCalendarSaga}
          // Download CSV
          transactionLoading={this.props.transactionLoading}
          downloadCsv={this.props.downloadCsv}
          disabled={false}
        />
        <MerchantsDiv>
          <MerchantTransactionTable
            transactionsFailedLoad={this.props.transactionsFailedLoad}
            transactionsLoading={this.props.transactionsLoading}
            expandedRow={this.props.expandedRow}
            expandRow={this.props.expandRow}
            transactions={this.props.transactions}
            currencies={this.props.currencies}
            paginatorTotal={this.props.paginatorTotal}
            currentPage={this.props.currentPage}
            changePage={this.props.changePage}
            previouslyVisited={this.props.previouslyVisited}
            orderBy={this.props.orderBy}
            orderDirection={this.props.orderDirection}
            changeSortOrder={this.props.changeSortOrder}
            showTooltip={this.props.showTooltip}
            activeTooltip={this.props.activeTooltip}
            perPage={this.props.perPage}
            setPerPage={this.props.setPerPageFilter}
            perPageOptions={[10, 25, 50]}
          />
        </MerchantsDiv>
      </>
    );
  }
}
const mapStateToProps = state => ({
  expandedRow: state.merchants.merchantTransactions.transactions.expandedRow,
  transactions: state.merchants.merchantTransactions.transactions.transactions,
  paginatorTotal: state.merchants.merchantTransactions.filters.pageCount,
  previouslyVisited:
    state.merchants.merchantTransactions.filters.previouslyVisited,
  currencies: state.global.currencies,
  transactionsFailedLoad:
    state.merchants.merchantTransactions.transactions.transactionsFailed,
  transactionsLoading:
    state.merchants.merchantTransactions.transactions.transactionsLoading,
  orderBy: state.merchants.merchantTransactions.transactions.orderBy,
  orderDirection:
    state.merchants.merchantTransactions.transactions.orderDirection,
  search: state.merchants.merchantTransactions.filters.search,
  commissionStatus:
    state.merchants.merchantTransactions.filters.commissionStatus,
  perPage: state.merchants.merchantTransactions.filters.perPage,
  currentPage: state.merchants.merchantTransactions.filters.currentPage,
  calendarFilterState:
    state.merchants.merchantTransactions.filters.calendarFilterState,
  startDate: state.merchants.merchantTransactions.filters.startDate,
  endDate: state.merchants.merchantTransactions.filters.endDate,
  activeTooltip:
    state.merchants.merchantTransactions.transactions.activeTooltip,
  viewportDevice: state.global.viewportDevice
});

const mapDispatchToProps = {
  expandRow,
  loadTransactions,
  changePage,
  downloadCsv,
  setSearchFilter,
  setCommissionStatusFilter,
  toggleCalendarFilter,
  clearCalendarFilter,
  setCalendarStartFilter,
  setCalendarEndFilter,
  setCalendarSaga,
  setPerPageFilter,
  changeSortOrder,
  showTooltip,
  resetState
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MerchantTransaction);
